import {combineReducers} from "redux";
import cutRegistrationReducer from './components/cutRegistration/cutRegistrationReducer'
import countriesReducer from "./components/countriesList/countriesReducer";
import statesReducer from "./components/statesList/statesReducer";
import postalCodeReducer from "./components/postalCode/postalCodeReducer";
import pinValidationReducer from "./components/pinValidation/pinValidationReducer";
import {RESET_FORM_ACTION} from "./components/shared/resetFormType";

const appReducer = combineReducers({
    registrationDetail: cutRegistrationReducer,
    countriesDetail: countriesReducer,
    statesDetail: statesReducer,
    postalCodeDetail: postalCodeReducer,
    pinValidationDetail: pinValidationReducer
})

const rootReducer = (state, action) => {
    if (action.type === RESET_FORM_ACTION) {
        state = undefined;
    }
    return appReducer(state, action);
}

export default rootReducer
